<template>
    <AddTypeDocumentModal />
  </template>
  
  <script lang="ts">
    import AddTypeDocumentModal from "@/components/GesCom/Document/AddTypeDocumentModal.vue";
import { defineComponent } from "vue";
  
      
    export default defineComponent({
      name: "AddTypeDocumentModalPage",
      components: {
        
        AddTypeDocumentModal,
      },
    });
  </script>